import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export const missingTranslationPrefix = 'Missing translation';
@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  public handle(params: MissingTranslationHandlerParams): string {
    console.error(`Missing translation with key ${params.key}`);
    return `[${missingTranslationPrefix}: ${params.key}]`;
  }
}
